import React from "react";
import { Spinner } from "components/common";
import { Label } from "components/bootstrap";
import useForwarder from "../../hooks/useForwarder";
const stateToStyle = (state) => {
  switch (state) {
    case "CONNECTED":
      return "default";
    case "DISCONNECTED":
      return "danger";
    default:
      return "warning";
  }
};
const stateToText = (state) => {
  switch (state) {
    case "CONNECTED":
      return "Connected";
    case "DISCONNECTED":
      return "Disconnected";
    default:
      return "Unknown";
  }
};
const ForwarderStatusCell = ({ forwarderId }) => {
  const { data, isFetching } = useForwarder(forwarderId != null ? forwarderId : "");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, "N/A");
  }
  if (isFetching && !data) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (!data) {
    return /* @__PURE__ */ React.createElement("em", null, "N/A");
  }
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: stateToStyle(data.state) }, stateToText(data.state));
};
export default ForwarderStatusCell;
